import {MessageBox,Message} from "element-ui";
import Vue from "vue";
const { alert, confirm } = MessageBox
//页签操作
Vue.prototype.$messageUi = Message
Vue.prototype.$alert = alert
Vue.prototype.$confirmUi = confirm
